import { fun_PostAction, fun_Download } from "@/api/index";
import { Loading } from "element-ui";
// 默认导出
export default {
  data() {
    return {
      // 列表loading初始状态
      loading: false,
      // 查询表单字段
      form: {
        fileName: null // 附件名称
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "附件名称：",
          value: "fileName",
          placeholder: "请输入"
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "附件名称",
          prop: "fileName",
          minWidth: "300"
        },
        {
          label: "发布时间 ",
          prop: "insertDate",
          minWidth: "150"
        },
        {
          label: "附件类型 ",
          prop: "fileTypeName",
          minWidth: "180"
        },
        {
          label: "操作",
          slotName: "op",
          minWidth: "50"
        }
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      fullLoading: false // 全局加载
    };
  },
  // 计算属性
  computed: {},
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
    document.body.style.cssText += ";overflow: visible;";
    // 查询一览数据
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取下载中心一览
     * @author liutong
     */
    fun_GetList() {
      // 打开加载loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/cmsNavigation/downloadCenterList", {
        ...this.form,
        ...this.reqPageData
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 列表数据
          this.tableData = data.records;
          // 总条数
          this.total = data.total;
          // 关闭加载
          this.loading = false;
        } else {
          // 关闭加载
          this.loading = false;
          // 错误提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 下载按钮
     * @author 滕威
     */
    fun_Download(e) {
      // 创建遮罩
      let fullLoading = Loading.service({
        lock: true,
        text: "下载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
      // 获取id
      fun_PostAction(
        "/cmsNavigation/fileDownload?id=" + e.id + "&type=" + "4"
      ).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 下载文件
          location.href =
            "/brs-server/downloadRedis?id=" +
            data.redisKey +
            "&fileName=" +
            data.fileName;
          // 关闭遮罩
          fullLoading.close();
        } else {
          // 关闭遮罩
          fullLoading.close();
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author shuhua
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author shuhua
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查询
     * @author shuhua
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 返回
     */
    fun_Back() {
      this.$router.push({ path: "/" });
    }
  }
};
